// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  TRIGGER: '[data-fragment="PopupForm.trigger"]',
  CLOSE: '[data-fragment="PopupForm.close"]'
};

export default class PopupForm extends WebComponent {
  constructor(props) {
    super(props);

    this.state = {
      popupOpened: false
    };

    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.handlePressEscButton = this.handlePressEscButton.bind(this);
  }

  didMount() {
    this.triggers = document.body.querySelectorAll(fragments.TRIGGER);
    [...this.triggers].map((item) => {
      if (item.dataset.target == this.element.id) {
        item.addEventListener('click', this.openPopup);
      }
    });
    this.on('click', fragments.CLOSE, this.closePopup);
    document.addEventListener("keydown", this.handlePressEscButton);

    if (window.getQueryParams()['openPopup'] == this.element.id) {
      this.setState({
        popupOpened: true
      });
    }
  }

  handlePressEscButton(e) {
    let flag = false;

    switch (e.code) {
      case 'Escape':
        this.closePopup();
        flag = true;
        break;
      default:
        break;
    }

    if (flag) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  openPopup = () => {
    this.setState({
      popupOpened: true
    });
  };

  closePopup = () => {
    this.setState({
      popupOpened: false
    });
  };

  willUnMount() {
    [...this.triggers].map((item) => {
      if (item.dataset.target == this.element.id) {
        item.addEventListener('click', this.openPopup);
      }
    });
    document.addEventListener("keydown", this.handlePressEscButton);
  }

  update() {
    const {popupOpened} = this.state;
    const {openPopupClassName} = this.props;
    classNames(this.element, {[openPopupClassName]: popupOpened});
    classNames(document.body, {'overflow-hidden': popupOpened});
  }
}

PopupForm.defaultProps = {
  openPopupClassName: "landing-popup-form--opened"
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/PopupForm.js